import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Star, Quote, Instagram, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const reviews = [
  {
    id: 1,
    name: 'Santosh K.',
    location: 'Siliguri',
    rating: 5,
    review: 'Finally found a store I can trust! The whey protein I bought had proper seal and authenticity code. Will definitely buy again.',
    date: '2 weeks ago',
    verified: true,
  },
  {
    id: 2,
    name: 'Bikash T.',
    location: 'Kathmandu',
    rating: 5,
    review: 'Ordered from Nepal and received within 5 days. Product was genuine ON Gold Standard. Amazing service!',
    date: '1 month ago',
    verified: true,
  },
  {
    id: 3,
    name: 'Amit R.',
    location: 'Jalpaiguri',
    rating: 5,
    review: 'The staff really knows their stuff. They recommended the perfect pre-workout for my training. Great results!',
    date: '3 weeks ago',
    verified: true,
  },
  {
    id: 4,
    name: 'Prakash M.',
    location: 'Darjeeling',
    rating: 5,
    review: 'Been buying from NutraFuel for 2 years now. Never had a single issue with authenticity. Highly recommended!',
    date: '1 week ago',
    verified: true,
  },
];

export const ReviewsSection = () => {
  return (
    <section className="py-20 md:py-28 bg-muted/50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <span className="inline-block text-gold font-semibold text-sm uppercase tracking-wider mb-4">TESTIMONIALS</span>
            <h2 className="section-title text-foreground">Customer Reviews</h2>
            <p className="section-subtitle mt-4">Real feedback from real customers across India & Nepal</p>
          </div>
          <Button variant="outline" asChild>
            <Link to="/reviews">
              All Reviews
              <ArrowRight className="w-4 h-4 ml-2" />
            </Link>
          </Button>
        </div>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {reviews.map((review, index) => (
            <Card
              key={review.id}
              className="bg-card border-0 shadow-soft hover:shadow-elevated transition-all duration-300 hover:-translate-y-2 flex flex-col"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <CardContent className="p-6 flex flex-col flex-1">
                {/* Quote Icon */}
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
                  <Quote className="w-5 h-5 text-primary" />
                </div>

                {/* Rating */}
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className={`w-4 h-4 ${i < review.rating ? 'fill-gold text-gold' : 'text-muted'}`}
                    />
                  ))}
                </div>

                {/* Review Text */}
                <p className="text-muted-foreground text-sm leading-relaxed mb-6 flex-1">
                  "{review.review}"
                </p>

                {/* Reviewer Info */}
                <div className="flex items-center justify-between mt-auto pt-4 border-t border-border">
                  <div>
                    <p className="font-semibold text-foreground text-sm">{review.name}</p>
                    <p className="text-xs text-muted-foreground">{review.location}</p>
                  </div>
                  {review.verified && (
                    <span className="inline-flex items-center gap-1 text-xs text-success font-medium">
                      <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      Verified
                    </span>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Social Proof Banner */}
        <div className="mt-16 text-center">
          <p className="text-muted-foreground mb-6">Follow us on Instagram for more reviews and updates</p>
          <Button variant="gold" size="lg" asChild>
            <a href="https://www.instagram.com/nutrafuel_supplements" target="_blank" rel="noopener noreferrer">
              <Instagram className="w-5 h-5 mr-2" />
              @nutrafuel
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};
